export default __webpack_public_path__ + "static/media/samar_seal.ae4ea3bc.png";